import { ChantContext } from '../../../nabc-renderer';
import { Rect } from '../../drawing';
import { LyricsTextMeasurer } from '../LyricsTextMeasurer';
import { ChantLayoutElement } from '../layout/ChantLayoutElement';

export class Commentary extends ChantLayoutElement {
  private readonly _text: string;

  get offset(): number {
    return this.bounds.height + this._context.commentaryraise;
  }

  constructor(
    protected readonly context: ChantContext,
    text: string,
  ) {
    super(context);
    this._text = text;
  }

  public performLayout(parentWidth: number): void {
    const bounds = LyricsTextMeasurer.instance.setElement(this.createTextElement()).getBBox();
    this.bounds = Rect.create(parentWidth, bounds.height, bounds.width, bounds.height);
  }

  private createTextElement() {
    const el = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    el.setAttribute('class', 'commentary');
    el.textContent = this._text;
    return el;
  }

  public createSvgFragments(): SVGElement[] {
    const el = this.createTextElement();
    el.setAttribute('x', this.bounds.x.toString());
    el.setAttribute('y', this.bounds.y.toString());
    el.setAttribute('text-anchor', 'end');
    return [
      el,
      ...super.createSvgFragments(),
    ];
  }
}
